import styled from "styled-components";
import { FC } from "react";

import { primaryActive, error } from "../../typography/alpha";

export enum SwitchGroupTestIds {
  Component = "switch-group",
}

type DirectionType = "row" | "column";

type ContainerProps = {
  $direction: DirectionType;
};

const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: ${({ $direction }): DirectionType => $direction};
  gap: ${({ $direction }): number => ($direction === "column" ? 12 : 24)}px;
`;

type LabelProps = {
  $error: boolean;
};

const Label = styled.div<LabelProps>`
  margin-bottom: 12px;
  ${({ $error }) => ($error ? error.subtitle3 : primaryActive.subtitle3)}
`;

const Error = styled.div`
  margin-top: 8px;
  ${error.caption}
`;

type Props = {
  label?: string;
  error?: string;
  direction?: DirectionType;
  className?: string;
  testId?: string;
};

export const SwitchGroup: FC<Props> = ({
  label = "",
  error = "",
  direction = "column",
  className,
  children,
  testId,
}) => (
  <div
    data-testid={testId ?? SwitchGroupTestIds.Component}
    className={className}
  >
    {label && <Label $error={Boolean(error)}>{label}</Label>}
    <Container $direction={direction}>{children}</Container>
    {error && <Error>{error}</Error>}
  </div>
);
